import ApplicationSerializer from 'cio/serializers/application';
import { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class MessageLimitSerializer extends ApplicationSerializer {
  normalize(type: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    // message limits don't come with an ID, so we add one
    if (hash) {
      hash.id = 'current';
    }

    /*
      campaigns_enabled comes in from the network with shape:
      {
        campaign_id_1: action_count,
        campaign_id_2: action_count,
        ...
      }
      We serialize this into 2 properties:
       - campaigns_enabled_ids allows for a hasMany campaigns relationship on the model
       - campaigns_enabled_message_counts is the action count

      The above also holds true for ABITB and Newsletters. For Newsletters, the action count
      value will always be 1.
    */

    hash.campaigns_enabled_ids = Object.keys(hash.campaigns_enabled);
    hash.campaigns_enabled_message_counts = hash.campaigns_enabled;
    delete hash.campaigns_enabled;

    hash.newsletters_enabled_ids = Object.keys(hash.newsletters_enabled);
    hash.newsletters_enabled_message_counts = hash.newsletters_enabled;
    delete hash.newsletters_enabled;

    hash.api_tbs_enabled_ids = Object.keys(hash.apitb_enabled);
    hash.api_tbs_enabled_message_counts = hash.apitb_enabled;
    delete hash.apitb_enabled;

    return super.normalize(type, hash, prop);
  }
}
